import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private ProductSettings Types */
import {
  Settings,
  _ProductSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedProductTemplate = {
  id: 0,
  name: '',
  product_description: {
    description: null
  }
}

export default {
  namespaced: true,
  state: {
    products: [],
    allProducts: [],
    selectedProduct: _.cloneDeep(selectedProductTemplate),
    addEditDialogState: false
  },
  mutations: {
    [_ProductSettings.mutations.setProducts] (state, payload) {
      state.products = payload
    },
    [_ProductSettings.mutations.setAllProducts] (state, payload) {
      state.allProducts = payload
    },
    [_ProductSettings.mutations.setSelectedProduct] (state, payload) {
      if (payload !== null) {
        state.selectedProduct = payload
      } else {
        state.selectedProduct = _.cloneDeep(selectedProductTemplate)
      }
    },
    [_ProductSettings.mutations.setDialogState] (state) {
      state.addEditDialogState = !state.addEditDialogState
    }
  },
  actions: {
    [_ProductSettings.actions.saveProduct] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/products'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ProductSettings.mutations.setSelectedProduct, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/products/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ProductSettings.mutations.setSelectedProduct, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_ProductSettings.actions.loadProducts] (context, payload) {
      console.log('loadProducts: ' + JSON.stringify(payload))
      console.log('loadProducts: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/products?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;reference:like;manufacturer.name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      if (payload.branch_office_id != null) {
        url += '&branch_office_id=' + payload.branch_office_id
      }

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ProductSettings.mutations.setProducts, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ProductSettings.actions.loadAllProducts] (context, payload) {
      console.log('loadAllProducts: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/products'

      if (payload !== null && typeof payload !== 'undefined') {
        if (typeof payload.fulltext !== 'undefined') {
          if (payload.fulltext) {
            url = API_URL + '/api/v1/products' + '?search=' + encodeURIComponent(payload.search) + '&fulltext=true'
          } else {
            url = API_URL + '/api/v1/products' + '?search=' + encodeURIComponent(payload.search) + '&searchFields=reference:like;'
          }
        } else {
          url = API_URL + '/api/v1/products' + '?search=' + encodeURIComponent(payload.search) + '&searchFields=reference:like;'
        }
      }

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ProductSettings.mutations.setAllProducts, r.data.data)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.getProductManufacturer] (context, payload) {
      console.log('loadAllProducts: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/products/' + encodeURIComponent(payload) + '/manufacturer'

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.loadProductByReference] (context, payload) {
      console.log('loadProductByReference: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/products/reference'

      const data = JSON.stringify(payload)

      console.log('search product by ref: ' + data)
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)

          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.searchProductsByReference] (context, payload) {
      console.log('searchProductsByReference: ' + JSON.stringify(payload))

      if (payload === null) {
        return
      }
      /*      var url = API_URL + '/api/v1/products&search=' + payload + '&searchFields=reference:like&orderBy=id&sortedBy=desc' */
      var url = API_URL + '/api/v1/products'
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ProductSettings.mutations.setAllProducts, r.data.data)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.saveProductDocument] (context, payload) {
      console.log('saveProductDocument: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productsDocuments'

      const data = JSON.stringify(payload)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.deleteProductDocument] (context, payload) {
      console.log('deleteProductDocument: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productsDocuments/' + payload.id

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.updateProductDocumentOrder] (context, payload) {
      console.log('updateProductDocumentOrder: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productsDocuments/' + payload.id + '/updateOrder'

      const data = JSON.stringify(payload)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductSettings.actions.openCloseDialog] ({ commit }) {
      commit(_ProductSettings.mutations.setDialogState)
    },
    [_ProductSettings.actions.setSelectedProduct] ({ commit }, payload) {
      commit(_ProductSettings.mutations.setSelectedProduct, payload)
    },
    [_ProductSettings.actions.resetState] ({ commit }, payload) {
      commit(_ProductSettings.mutations.setProducts, [])
      commit(_ProductSettings.mutations.setAllProducts, [])
      commit(_ProductSettings.mutations.setSelectedProduct, null)
    }
  },
  getters: {
    [_ProductSettings.getters.products] (state) {
      return state.products
    },
    [_ProductSettings.getters.getAllProducts] (state) {
      return state.allProducts
    },
    [_ProductSettings.getters.getDialogState] (state) {
      return state.addEditDialogState
    },
    [_ProductSettings.getters.getSelectedProduct] (state) {
      return state.selectedProduct
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/products.js